import _ from 'lodash';
import PropTypes from 'prop-types';
import { Fragment, memo } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import currencySymbol from '../../../helpers/currencySymbol';
import { seatConfirmedStatusCodes } from '../../../constants';

const FlightSeatsInfo = ({ passengers, itinerary }) => {
  const router = useRouter();

  const allFlights = _.flatMap(itinerary.flightSegments, (seg) => seg.flights);
  const isCheckoutPage = router.pathname.indexOf('checkout') > -1;

  return (
    <div className="grid grid-cols-3 text-sm">
      {passengers.map((p, index) => (
        p.travelerPreferences && p.travelerPreferences.flightSeatNumbers
    && Object.keys(p.travelerPreferences.flightSeatNumbers || {})
      .map((key, pIndex) => {
        if (!p.travelerPreferences.flightSeatNumbers[key]) return false;
        const flight = _.find(allFlights, (f) => f.flightNumber === key);
        return flight ? (
          <Fragment key={key}>
            {pIndex === 0 && (
              <div className="font-bold col-span-3">
                Passenger
                {' '}
                {index + 1}
                :
              </div>
            )}
            <div className="col-span-2">
              {`${flight.carrierCode} ${key} (${flight.originAirportCode}-${flight.destinationAirportCode}) - Seat: ${p.travelerPreferences.flightSeatNumbers[key].seatNumber}`}
            </div>
            <div className="text-right">
              {currencySymbol(itinerary.cost.currencyCode)}
              {p.travelerPreferences.flightSeatNumbers[key].price}
            </div>
            <div className="col-span-3 mb-2">
              {p.travelerPreferences.flightSeatNumbers[key]
                  && p.travelerPreferences.flightSeatNumbers[key].emdNumber && (
                  <div>
                    <b>EMD #:</b>
                    {' '}
                    {p.travelerPreferences.flightSeatNumbers[key].emdNumber}
                  </div>
              )}
              {!isCheckoutPage && (
              <div>
                <b>Status: </b>
                <span className={clsx(!p.travelerPreferences.flightSeatNumbers[key].seatStatusCode || !seatConfirmedStatusCodes.includes(p.travelerPreferences.flightSeatNumbers[key].seatStatusCode) ? 'bg-red-200' : undefined)}>
                  {p.travelerPreferences.flightSeatNumbers[key].seatStatus || 'Seat is not confirmed.'}
                </span>
              </div>
              )}
            </div>
          </Fragment>
        ) : <></>;
      })
      ))}
    </div>
  );
};

FlightSeatsInfo.propTypes = {
  passengers: PropTypes.shape().isRequired,
  itinerary: PropTypes.shape().isRequired,
};
export default memo(FlightSeatsInfo);
